//mui/material-ui/blob/v5.12.1/docs/data/material/components/autocomplete/GoogleMaps.tsx

// Need to enable all 4 of the following for it to work.
// Google Maps JavaScript API - https://console.cloud.google.com/apis/api/maps-backend.googleapis.com/overview?project=rent-iq
// Google Maps Geocoding API - https://console.cloud.google.com/apis/api/geocoding-backend.googleapis.com/overview?project=rent-iq
// Google Maps Places API - https://console.cloud.google.com/apis/api/places-backend.googleapis.com/overview?project=rent-iq
// Google Maps Directions API - https://console.cloud.google.com/apis/api/directions-backend.googleapis.com/overview?project=rent-iq
export const GOOGLE_MAPS_API_KEY = 'AIzaSyAsl4q_Thc5b9dkYHadSb_AKdHR8JtJyNM'

export const loadScript = (src: string, position: HTMLElement | null, id: string, cb: Function) => {
  if (!position) {
    return
  }
  (window as any).loadedGoogleMaps = () => {
    console.log(`Loaded Google Maps js`)
    cb()
  }
  const script = document.createElement('script')
  script.setAttribute('async', '')
  script.setAttribute('id', id)
  script.src = src
  position.appendChild(script)
}

export const autocompleteService = { current: null }

export interface MainTextMatchedSubstrings {
  offset: number
  length: number
}
export interface StructuredFormatting {
  main_text: string
  secondary_text: string
  main_text_matched_substrings?: readonly MainTextMatchedSubstrings[]
}
export interface PlaceType {
  place_id: string
  description: string
  structured_formatting: StructuredFormatting
}